import { render, staticRenderFns } from "./SaitenBoxScoreStamp.vue?vue&type=template&id=1db336a8&scoped=true&"
import script from "./SaitenBoxScoreStamp.vue?vue&type=script&lang=ts&"
export * from "./SaitenBoxScoreStamp.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenBoxScoreStamp.vue?vue&type=style&index=0&id=1db336a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db336a8",
  null
  
)

export default component.exports